import { CanMatchFn } from '@angular/router';
import { inject } from '@angular/core';
import { PermissionsService } from '../../core/services/permissions.service';

export const permissionGuard: CanMatchFn = route => {
  const _permissionsService = inject(PermissionsService);
  const requiredPerm: string | undefined = route.data ? route.data['permission'] : undefined;
  const isPublic: string | undefined = route.data ? route.data['isPublic'] : undefined;

  if (isPublic) return true;

  if (!requiredPerm) {
    console.warn('Permission not found', route);
    return false;
  }
  return _permissionsService.has(requiredPerm);
};
